export type TooltipDirection =
  | 'top-left'
  | 'top'
  | 'top-right'
  | 'left-top'
  | 'left'
  | 'left-bottom'
  | 'right-top'
  | 'right'
  | 'right-bottom'
  | 'bottom-left'
  | 'bottom'
  | 'bottom-right'
export type TooltipVariants = 'text' | 'translate'
export type TooltipColors = 'dark' | 'white'

export type AnchorBoundingRect = {
  top: number
  left: number
  width: number
  height: number
}

export type ElementBoundingRect = {
  top: number
  left: number
  right: number
  bottom: number
  centerX: number
  centerY: number
  width: number
  height: number
}

export type EdgePositionStyle = {
  top?: number
  left?: number
  right?: number
  bottom?: number
}

export type TooltipPositionStyle = Record<TooltipDirection, EdgePositionStyle>

export const tooltipDefaultDirection: TooltipDirection = 'top'
export const tooltipDefaultVariant: TooltipVariants = 'text'
export const tooltipDefaultColor: TooltipColors = 'dark'

export type TmTooltipPersistence = {
  isOpen: boolean
}

export type TmAngleWrapTooltipPropsType = {
  direction?: TooltipDirection
  color?: TooltipColors
  offset?: [number, number]
  // Resets styles for the container of the tooltip content
  custom?: boolean
  viewportWidth?: number
  viewportHeight?: number
  anchorBounding?: ElementBoundingRect
  tooltipPosition?: EdgePositionStyle & { height: number }
}

export type TmBaseTooltipPropsType = {
  direction?: TooltipDirection
  color?: TooltipColors
  offset?: [number, number]
  interactive?: boolean
  anchorElement?: HTMLElement
  disabled?: boolean
  delay?: number
  // If persistence is provided, the tooltip will be opened or closed depending on the isOpen value
  persistence?: TmTooltipPersistence
  // Resets styles for the container of the tooltip content
  custom?: boolean
}

export type TmTextTooltipPropsType = TmBaseTooltipPropsType & {
  variant?: 'text'
  text: string
  textAlign?: 'left' | 'center' | 'right'
  html?: boolean
}

export type TmTranslateTooltipPropsType = TmBaseTooltipPropsType & {
  variant: 'translate'
  keypath: string | Record<string, any>
  /**
   * Open links on mousedown via window.open()
   * to prevent outside-click interception
   */
  openLinkOnMousedown?: boolean
}

export type TmTooltipDirectiveData = TmTextTooltipPropsType | TmTranslateTooltipPropsType

export type TmTooltipDirectiveBinding = TmTooltipDirectiveData | '' | undefined
